import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import CustomModal from './Modal';
import { I18nContext } from 'utils/I18n/context';

const LandingPreview = ({isVisible, url, width, height, title, onClose}) => {
    const { t = {} } = useContext(I18nContext) || {};
    const staticNames = t?.offersPage?.offer || {};

    if (!url) {
        return null;
    }

    return (
        <CustomModal
            visible={isVisible}
            onClose={onClose}
            title={staticNames.landingPreview || title}
            areNoControls={true}
            className={'modal-responsive modal-banner'}
        >
            <div className="banner-preview">
                <div className="banner-preview__wrapp">
                    <div className="banner-preview__axis banner-preview__axis_y">
                        <div className="banner-preview__size">{height}px</div>
                    </div>
                    <div className="banner-preview__axis banner-preview__axis_x">
                        <div className="banner-preview__size">{width}px</div>
                    </div>
                    <img className="banner-preview__image" src={url} alt={title} />
                </div>
            </div>
        </CustomModal>
    )
};

LandingPreview.propTypes = {
    isVisible: PropTypes.bool,
    url: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    title: PropTypes.string,
    onClose: PropTypes.func,
};

export default LandingPreview;
